import styled from 'styled-components';

export const Container = styled.ul`
  justify-content: start;
  flex-wrap: wrap;
  align-items: center;
  background: ${({ theme }) => theme.colors.primary};
  padding: 0.5rem 0;
  border-radius: 0.5rem;

  a {
    color: ${({ theme }) => theme.colors.textPrimary};
    padding: 0 0.5rem;
    font-weight: 600;
    font-size: 0.9rem;
    position: relative;

    &::before {
      content: '/';
      position: absolute;
      top: 1px;
      right: -4px;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.textSecondary};
    }
  }

  span {
    font-weight: 600;
    font-size: 0.9rem;
    color: ${({ theme }) => theme.colors.textSecondary};
    margin-left: 0.5rem;
  }
`;
